import type { Card } from '../../types';

export const GUARD: Card = {
  id: 'guard',
  name: 'Guard',
  type: 'defense',
  rarity: 'common',
  size: { w: 1, h: 1 },
  cost: [{ kind: 'min', value: 1 }],
  effects: [{ kind: 'block', amount: 3 }],
};
